import React, { useState, useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { TextField } from '@material-ui/core'
import Swal from 'sweetalert2';
import { Autocomplete } from '@material-ui/lab'
import {
    useNavigate
} from "react-router-dom";

// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';
import Loading from '../../../components/modales/loadingModal';

// APIs
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const actualizarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');
const eliminarListas = functionsHttpsCallable('ape_eliminarLista');

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalDesistimiento = (props) => {
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [loading, setLoading] = useState(false);
    const navigate  = useNavigate(); 
    const [razon, setRazon] = useState(undefined);

    const razones = [
        'No esta de acuerdo con las condiciones contractuales',
        'El Candidato no asiste a la firma del contrato',
        'Fuerza mayor de parte del Candidato',
        'Se Cancela Contratacion por solicitud de operaciones'
    ];

    const handleDevolver = async () => {
        setLoading(true);
        const body = {
            cod_soli: props.id,
            cod_empr: userData.codigoEmpresa,
            data: {
                cmp_stat: 'VALIDACION_RECLUTADOR',
                // cod_actu: props.data.flujo.cedulaReclutador,
                motivoDesistimiento: razon
            },

        }
        const body2 = {
            ape: props.id,
            cod_empr: userData.codigoEmpresa,

        }
        await actualizarAPE(body);
        await eliminarListas(body2);
        Swal.fire({
            title: "Proceso desistido",
            text: `Proceso desistido por la razón: ${razon}`,
            icon: "success"
        });
        navigate('/home/proceso-contratacion');
        setLoading(false)
    }

    const renderBody = () => {
        return (
            <div>
                <div>
                    <Row style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
                        {/* <Col lg='3' md='3' xs='12'>
                            <TextField
                                variant='outlined'
                                required
                                type='time'
                                autoComplete='off'
                                key={`hora`}
                                id={`hora`}
                                fullWidth
                                margin='normal'
                                onChange={(e) => { actualizarObjetoCreacion(e.target.id, e.target.value) }}
                                // onChange={(e) => { console.log(e.target.id, e.target.value) }}
                            />
                        </Col> */}
                        <Col lg='12' md='12' xs="12" className='informe-final-select'>
                            <Autocomplete
                                required
                                margin="dense"
                                options={razones}
                                key={`key_TipoDeContrato`}
                                id={`select_TipoDeContrato`}
                                onChange={(event, newValue) => setRazon(newValue)}
                                renderInput={(params) => (
                                    <TextField {...params} label={'Razón'} margin="normal" />
                                )}
                                getOptionLabel={(option) => option}
                                renderOption={(option) => (
                                    <React.Fragment>
                                        {option}
                                    </React.Fragment>
                                )}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }

    if (loading) { return <div className={'loading-area'}> <Loading /> </div> }
    else return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                buttonTitle={'Desistir'}
                onClick={() => { handleDevolver() }}
                buttonLoading={!(razon !== undefined)}
                title={`Desistir proceso`}
            >
                {renderBody()}
            </CustomModal>
        </React.Fragment>
    );

}

export default connect(mapStateToProps)(ModalDesistimiento);